import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { country, CountryManipulationViewModel } from "./countryManipulation-viewModel";

export class CountryManipulationView extends View<CountryManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-BFEF9F5C-DB8E-46AC-8F55-8DE3F2B81847"
    }
    loadHtml(): string {
        let element = require('./countryManipulation.html').default;
        let style = require('./countryManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    public set countries(v: ObservableArray<country>) { this._countries = v; } public get countries(): ObservableArray<country> { return this._countries;} private _countries: ObservableArray<country>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestCountryCreation(){
        this.dataContext.requestCountryCreation();
    }
}
